define('environments/test',{
  env: "test",
  defaultDomain: "https://signup.test.mdirector.com/",
  backendUrl: "https://signup-backend.test.mdirector.com",
  mdirectorUrl: "https://app.test.mdirector.com",
  mdirectorPrivateUrl:
    "https://app.test.mdirector.com/private?redirect=dashboard",
  landingsUrl: "https://landings.test.mdirector.com",
  transUrl: "https://trans.test.mdirector.com",
  automationUrl: "https://automation.test.mdirector.com",
  authUrl: "https://auth.test.mdirector.com",
  paymentsUrl: "https://payments.test.mdirector.com/",
  captchaPublicKey: "6LeP380UAAAAANdkQPCqAs8UGGhwoti0x7Pjg8Mc",
  i18nCookieDomain: ".test.mdirector.com",
  getProvincesUrl:
    "https://signup-backend.test.mdirector.com/provinces/country/",
  getCountriesUrl: "https://signup-backend.test.mdirector.com/countries",
  getUserDataUrl: "https://signup-backend.test.mdirector.com/signup/",
  postUserServicesUrl:
    "https://signup-backend.test.mdirector.com/user-services",
  submitUrl: "https://signup-backend.test.mdirector.com/signup",
  themeAssetsUrl: "https://static.test.mdirector.com/assets/themes/",
  registerUrl: {
    es: "https://www.test.mdirector.com/signup/",
    fr: "https://www.test.mdirector.com/fr/signup/",
    it: "https://www.test.mdirector.com/it/signup/",
    pt: "https://www.test.mdirector.com/pt/signup/",
    en: "https://www.test.mdirector.com/en/signup/",
  },
  ga: {
    ua: "UA-46499122-1",
    tagmanagerId: "GTM-WX6H3W",
    domain: "mdirector.com",
  },
  trackingFirstStepDefaultParams: {
    origin: "web",
    service: "mdirector",
    productId: "emailmarketing",
    productName: "Email Marketing",
    landingName: "No_LANDING_Direct_Registry",
  },
  securityOptionsAllowGroups: [],
  SECURE_PASSWORD_LENGTH: 8,
  maintenanceUrl: "https://static.test.mdirector.com/assets/js/maintenance.js",
  CPSAgreements: {
    cookieDismissName: "CPSAgreementsDismiss",
    cookieDismissValue: "ok",
    cookieDismissExpirationDays: 1,
    externalTermsURL: {
      es: "https://pmp.antevenio.com/mdirector/cps-mdirector-esp-es",
      en: "https://pmp.antevenio.com/mdirector/cps-mdirector-eng-es",
      it: "https://pmp.antevenio.com/mdirector-it/md-cps-it",
    },
    canBeDelayed: false,
  },
  integrations: {
    zapierEnabled: true,
    shopifyEnabled: true,
    APIsEnabled: true,
  },
  showTransArray: ["20950", "20941"],
  showBalanceArray: ["20950", "20941", "1609", "400584"],
});

